import {BASE_PATH, CURRENT_PRODUCT, Product, ProductWebSiteURLs} from '../../constants'
import URI from 'urijs'

export const ManageLicensesUrl = URI.joinPaths(BASE_PATH, 'administration/manage_licenses.do')

export const AddonsMenuGuideURLs = {
    ZAPIER_GUIDE_URL: ProductWebSiteURLs.CURRENT_PRODUCT_SITE_URL + 'actitime-zapier',
    API_GUIDE_URL: ProductWebSiteURLs.CURRENT_PRODUCT_SITE_URL + 'actitime-api',
    EXTENSION_GUIDE_URL: ProductWebSiteURLs.CURRENT_PRODUCT_SITE_URL + 'browser-extension',
    MOBILE_GUIDE_URL: ProductWebSiteURLs.CURRENT_PRODUCT_SITE_URL + (CURRENT_PRODUCT === Product.actiTIME ? 'actitime-mobile-app' : 'mobile'),
}

export const AddonsMenuActionUrls = {
    QBI_ACTION_URL: URI.joinPaths(BASE_PATH, 'switch-to-integrator.do'),
    ZAPIER_ACTION_URL: 'https://zapier.com/apps/actitime/integrations',
    API_ACTION_URL: URI.joinPaths(BASE_PATH, 'api/v1/swagger'),
    EXTENSION_ACTION_URL: 'https://chrome.google.com/webstore/detail/actitime-time-tracking-pr/oogddkbohgikljeadnkcepdmekigegck?hl=en',
    AT_MOBILE_IOS_ACTION_URL: 'https://apps.apple.com/us/app/actitime-mobile-timesheet/id517216049',
    AT_MOBILE_ANDROID_ACTION_URL: 'https://play.google.com/store/apps/details?id=com.actimind.actitime',
    AP_MOBILE_IOS_ACTION_URL: 'https://apps.apple.com/app/actiplans-absence-notes/id1049307705',
    AP_MOBILE_ANDROID_ACTION_URL: 'https://play.google.com/store/apps/details?id=com.actimind.actiplans.android',
}

export const AddonsCardsModels = {
    AP_INTEGRATION: {
        additionalIconClass: 'apIcon',
        titleTextKey: 'menu.addons.item.actiplans.title',
        titleLink: ProductWebSiteURLs.OTHER_PRODUCT_INTEGRATION_URL,
        descriptionTextKey: 'menu.addons.item.actiplans.description',
        notAvailableButtonTextKey: 'menu.addons.item.not_available_button',
    },
    AT_INTEGRATION: {
        additionalIconClass: 'atIcon',
        titleTextKey: 'menu.addons.item.actitime.title',
        titleLink: ProductWebSiteURLs.OTHER_PRODUCT_INTEGRATION_URL,
        descriptionTextKey: 'menu.addons.item.actitime.description',
    },
    QBI: {
        additionalIconClass: 'qbiIcon',
        titleTextKey: 'menu.addons.item.qbi.title',
        titleLink: ProductWebSiteURLs.QBI_INTEGRATOR_GUIDE_URL,
        descriptionTextKey: 'menu.addons.item.qbi.description',
        actionButtonTextKey: 'menu.addons.item.qbi.button',
        notAvailableButtonTextKey: 'menu.addons.item.not_available_button',
    },
    ZAPIER: {
        additionalIconClass: 'zapierIcon',
        titleTextKey: 'menu.addons.item.zapier.title',
        titleLink: AddonsMenuGuideURLs.ZAPIER_GUIDE_URL,
        descriptionTextKey: 'menu.addons.item.zapier.description',
        actionButtonTextKey: 'menu.addons.item.zapier.button',
        notAvailableButtonTextKey: 'menu.addons.item.not_available_button',
    },
    API: {
        additionalIconClass: 'apiIcon',
        titleTextKey: 'menu.addons.item.api.title',
        titleLink: AddonsMenuGuideURLs.API_GUIDE_URL,
        descriptionTextKey: 'menu.addons.item.api.description',
        actionButtonTextKey: 'menu.addons.item.api.button',
        notAvailableButtonTextKey: 'menu.addons.item.not_available_button',
    },
    BROWSER_EXTENSION: {
        additionalIconClass: 'extensionIcon',
        titleTextKey: 'menu.addons.item.extension.title',
        titleLink: AddonsMenuGuideURLs.EXTENSION_GUIDE_URL,
        descriptionTextKey: 'menu.addons.item.extension.description',
        actionButtonTextKey: 'menu.addons.item.extension.button',
        notAvailableButtonTextKey: 'menu.addons.item.not_available_button',
    },
    MOBILE: {
        titleTextKey: 'menu.addons.item.mobile.title',
        titleLink: AddonsMenuGuideURLs.MOBILE_GUIDE_URL,
        descriptionTextKey: 'menu.addons.item.mobile.description',
    },
}


// WEBPACK FOOTER //
// ./web/js/support/addons/constants.js